import React, {forwardRef} from "react"
import classNames from "classnames"
import styles from "./Checkbox.module.scss"
import {Text} from "../Text/Text"
import {OverflowTextHint} from "../OverflowTextHint/OverflowTextHint"

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string
    labelClassName?: string
    forYellowBg?: boolean
    whiteCell?: boolean
    inputClassName?: string
    darkLabel?: boolean
    greyText?: boolean
    yellowCell?: boolean
    partiallyChecked?: boolean
    darkDisabledLabel?: boolean
    limitedWidth?: number
    "data-cy"?: string
    "data-test"?: string
    canUncheckIfDisabled?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    (
        {
            className,
            labelClassName,
            inputClassName,
            label,
            children,
            forYellowBg,
            whiteCell,
            darkLabel,
            greyText,
            yellowCell,
            partiallyChecked,
            darkDisabledLabel,
            limitedWidth,
            canUncheckIfDisabled,
            ...props
        },
        ref
    ) => {
        return (
            <label
                className={classNames(
                    styles["checkbox-component"],
                    {
                        [styles["-for-yellow"]]: forYellowBg,
                        [styles["-darkLabel"]]: darkLabel,
                        [styles.greyText]: greyText,
                        [styles.partial]: partiallyChecked && !props.checked,
                    },
                    className
                )}
                data-test="checkbox"
            >
                <input
                    tabIndex={-1}
                    className={classNames(
                        styles["input"],
                        {
                            [styles.darkDisabledLabel]: darkDisabledLabel,
                            [styles.checked]: props.checked,
                        },
                        inputClassName
                    )}
                    type="checkbox"
                    ref={ref}
                    {...props}
                    disabled={
                        canUncheckIfDisabled
                            ? props.checked
                                ? false
                                : props.disabled
                            : props.disabled
                    }
                    capture={undefined}
                />
                <span
                    className={classNames(styles["cell"], {
                        [styles["-white"]]: whiteCell,
                        [styles["-yellow"]]: yellowCell,
                    })}
                >
                    <div className={styles["icon"]} />
                </span>
                {typeof label === "string" ? (
                    <OverflowTextHint
                        className={classNames(labelClassName, styles.label)}
                        text={label}
                        baseMaxWidth={limitedWidth ?? "100%"}
                    />
                ) : label || children ? (
                    <Text
                        className={classNames(labelClassName, styles.label)}
                        limitedWidth={limitedWidth + "rem"}
                        data-test={props["data-test"] + "-label"}
                    >
                        {label || children}
                    </Text>
                ) : null}
            </label>
        )
    }
)
